const VALIDATOR_TYPE_REQUIRE = 'REQUIRE';
const VALIDATOR_TYPE_MINLENGTH = 'MINLENGTH';
const VALIDATOR_TYPE_MAXLENGTH = 'MAXLENGTH';
const VALIDATOR_TYPE_MIN = 'MIN';
const VALIDATOR_TYPE_MAX = 'MAX';
const VALIDATOR_TYPE_EMAIL = 'EMAIL';
const VALIDATOR_TYPE_FILE = 'FILE';
const VALIDATOR_TYPE_NAME = 'NAME';
const VALIDATOR_TYPE_NAME_SPEEDS_TSI = 'NAMESPEEDSTSI';
const VALIDATOR_TYPE_PASSWORD = 'PASSWORD';
const VALIDATOR_TYPE_SERIAL_NUMBER = 'SERIALNUMBER';
const VALIDATOR_TYPE_OPTIONAL_HEAT_RANGE = 'OPTIONAL_HEAT_RANGE';

// Letters, combining marks and numbers from every Unicode script. The
// katakana middle dot is commonly part of Japanese product and recipe names.
const UNICODE_NAME_PATTERN = /^[\p{L}\p{M}\p{N}\s\u30FB]+$/u;
const UNICODE_NAME_WITH_SYMBOLS_PATTERN = /^[\p{L}\p{M}\p{N}\s\u30FB@#%&*\-+()!"<>':;/?.,]+$/u;

type validatorRequireType = { type: typeof VALIDATOR_TYPE_REQUIRE; };
type validatorFileType = { type: typeof VALIDATOR_TYPE_FILE; };
type validatorMinLengthType = { type: typeof VALIDATOR_TYPE_MINLENGTH; val: number; };
type validatorMaxLengthType = { type: typeof VALIDATOR_TYPE_MAXLENGTH; val: number; };
type validatorMinType = { type: typeof VALIDATOR_TYPE_MIN; val: number };
type validatorMaxType = { type: typeof VALIDATOR_TYPE_MAX; val: number };
type validatorEmailType = { type: typeof VALIDATOR_TYPE_EMAIL; };
type validatorNameType = { type: typeof VALIDATOR_TYPE_NAME; };
type validatorNameSpeedTsiType = { type: typeof VALIDATOR_TYPE_NAME_SPEEDS_TSI; };
type validatorPasswordType = { type: typeof VALIDATOR_TYPE_PASSWORD; };
type validatorSerialNumberType = { type: typeof VALIDATOR_TYPE_SERIAL_NUMBER; };
type validatorOptionalHeatRangeType = { type: typeof VALIDATOR_TYPE_OPTIONAL_HEAT_RANGE; };

export type validatorType =
  | validatorRequireType
  | validatorFileType
  | validatorMinLengthType
  | validatorMaxLengthType
  | validatorMinType
  | validatorMaxType
  | validatorEmailType
  | validatorNameType
  | validatorNameSpeedTsiType
  | validatorPasswordType
  | validatorSerialNumberType
  | validatorOptionalHeatRangeType

export const VALIDATOR_REQUIRE = (): validatorRequireType => ({ type: VALIDATOR_TYPE_REQUIRE });
export const VALIDATOR_FILE = (): validatorFileType => ({ type: VALIDATOR_TYPE_FILE });
export const VALIDATOR_MINLENGTH = (val: number): validatorMinLengthType => ({
  type: VALIDATOR_TYPE_MINLENGTH,
  val: val,
});
export const VALIDATOR_MAXLENGTH = (val: number): validatorMaxLengthType => ({
  type: VALIDATOR_TYPE_MAXLENGTH,
  val: val,
});
export const VALIDATOR_MIN = (val: number): validatorMinType => ({
  type: VALIDATOR_TYPE_MIN,
  val: val,
});
export const VALIDATOR_MAX = (val: number): validatorMaxType => ({
  type: VALIDATOR_TYPE_MAX,
  val: val,
});
export const VALIDATOR_EMAIL = (): validatorEmailType => ({ type: VALIDATOR_TYPE_EMAIL });
export const VALIDATOR_NAME = (): validatorNameType => ({ type: VALIDATOR_TYPE_NAME });
export const VALIDATOR_NAME_SPEEDS_TSI = (): validatorNameSpeedTsiType => ({ type: VALIDATOR_TYPE_NAME_SPEEDS_TSI });
export const VALIDATOR_PASSWORD = (): validatorPasswordType => ({ type: VALIDATOR_TYPE_PASSWORD });
export const VALIDATOR_SERIAL_NUMBER = (): validatorSerialNumberType => ({ type: VALIDATOR_TYPE_SERIAL_NUMBER });
export const VALIDATOR_OPTIONAL_HEAT_RANGE = (): validatorOptionalHeatRangeType => ({ type: VALIDATOR_TYPE_OPTIONAL_HEAT_RANGE });

export const validate = (value: string, validators: validatorType[]) => {
  let isValid = true;
  for (const validator of validators) {
    if (validator.type === VALIDATOR_TYPE_REQUIRE) {
      isValid = isValid && !!value && typeof value === "string" && value.trim().length > 0;
    }
    if (validator.type === VALIDATOR_TYPE_MINLENGTH) {
      isValid = isValid && !!value && value.trim().length >= validator.val;
    }
    if (validator.type === VALIDATOR_TYPE_MAXLENGTH) {
      isValid = isValid && !!value && value.trim().length <= validator.val;
    }
    if (validator.type === VALIDATOR_TYPE_MIN) {
      (!value || (isValid = isValid && +value >= validator.val));
    }
    if (validator.type === VALIDATOR_TYPE_MAX) {
      (!value || (isValid = isValid && +value <= validator.val));
    }
    if (validator.type === VALIDATOR_TYPE_EMAIL) {
      isValid = isValid && /^\S+@\S+\.\S+$/.test(value);
    }
    if (validator.type === VALIDATOR_TYPE_NAME) {
      isValid = isValid && UNICODE_NAME_PATTERN.test(value);
    }
    if (validator.type === VALIDATOR_TYPE_NAME_SPEEDS_TSI) {
      isValid = isValid && UNICODE_NAME_WITH_SYMBOLS_PATTERN.test(value);
    }
    if (validator.type === VALIDATOR_TYPE_PASSWORD) {
      isValid = isValid && /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/.test(value);
    }
    if (validator.type === VALIDATOR_TYPE_SERIAL_NUMBER) {
      isValid = isValid && /^[A-Za-z0-9; ]+$/.test(value);
    }
    if (validator.type === VALIDATOR_TYPE_OPTIONAL_HEAT_RANGE) {
      const trimmedValue = typeof value === 'string' ? value.trim() : '';

      if (trimmedValue.length === 0) {
        continue;
      }

      const numericValue = Number(trimmedValue);

      if (!Number.isFinite(numericValue)) {
        isValid = false;
        continue;
      }

      if (numericValue === 0) {
        continue;
      }

      if (!Number.isInteger(numericValue)) {
        isValid = false;
        continue;
      }

      isValid = isValid && numericValue >= 5 && numericValue <= 59;
    }

  }
  return isValid;
};
